import { Component, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { RouteOption, routeOptions } from '../../interfaces/data/delegate';
import { MrpScrolltopComponent } from '../../services/mrp-scrolltop/mrp-scrolltop.component';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatSelect, MatOption } from '@angular/material/select';


@Component({
    selector: 'app-roberts',
    templateUrl: './roberts.component.html',
    styleUrls: ['./roberts.component.css'],
    imports: [MrpScrolltopComponent, MatFormField, MatLabel, MatSelect, MatOption, RouterLink]
})
export class RobertsComponent implements OnInit {

delegateroutes: RouteOption[] = routeOptions; 

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  onRouteSelect(path: string): void {
    if (path) {
      this.router.navigate([path]);
    }
  }

}
